export const HAPPY_READING_QUERY_ACTION = 'happy-reading';

export const LOADING_SNACKBAR_ID = 'convert-fb2-to-epub-loading';
export const FAILURE_SNACKBAR_ID = 'convert-fb2-to-epub-failure';
